const SOUND_RE = /(?:^|\s)#sound:([^\s#]+)/i
export const AUDIO_FILE = /\.(mp3|wav|m4a|aac|ogg|flac)$/i

export const parseSoundId = (tags) => {
  const match = String(tags || '').match(SOUND_RE)
  return match ? String(match[1]) : ''
}

export const visibleTags = (tags) => String(tags || '').replace(SOUND_RE, '').replace(/\s+/g, ' ').trim()

export const withSoundTag = (tags, soundId) => {
  const clean = visibleTags(tags)
  if (!soundId) return clean
  return [clean, `#sound:${soundId}`].filter(Boolean).join(' ')
}

export const soundIdOf = (item) => {
  const tagged = parseSoundId(item && item.tages)
  if (tagged) return tagged
  return item && item.id ? String(item.id) : ''
}

export const usesSound = (item, soundId) => {
  if (!item || !soundId) return false
  const tagged = parseSoundId(item.tages)
  if (tagged) return tagged === String(soundId)
  return String(item.id) === String(soundId)
}

export const findSoundSource = (soundId, lists) => {
  if (!soundId) return null
  const all = lists.flatMap((list) => (Array.isArray(list) ? list : []))
  return all.find((item) => String(item && item.id) === String(soundId)) || null
}
